import { AAQuestionnaireQuestion } from "./aa_questionnaire_question";
import { Model } from "./model";

export class AAQuestionnaire extends Model {
	private data: AAQuestionnaireQuestion[] = [];

	public getQuestions(): AAQuestionnaireQuestion[] {
		return this.data;
	}

	public setQuestions(list: AAQuestionnaireQuestion[]): void {
		this.data = list;
	}
}
